import {
	changeSize,
	changeVersion,
	decreaseModifierLevel,
	decreaseModifierQuantity,
	deselectModifier,
	increaseModifierLevel,
	increaseModifierQuantity,
	selectModifier,
	selectProduct
} from '@biggby-coffee/percomatic-typescript/dist/src/api';
import { makeApiCallHook } from '../../utils/makeApiCallHook';

/*
	THE ONLY THING THAT SHOULD BE ADDED TO THIS FILE ARE ADDITIONAL API CALL
	WRAPPER HOOKS WHEN NEW API METHODS ARE ADDED TO PERCOMATIC
	DO NOT ADD HOOKS WITH AN ACTUAL IMPLEMENTATION TO THIS FILE
*/

export const useChangeSize = makeApiCallHook('changeSize', changeSize);

export const useChangeVersion = makeApiCallHook('changeVersion', changeVersion);

export const useDecreaseModifierLevel = makeApiCallHook(
	'decreaseModifierLevel',
	decreaseModifierLevel
);

export const useDecreaseModifierQuantity = makeApiCallHook(
	'decreaseModifierQuantity',
	decreaseModifierQuantity
);

export const useDeselectModifier = makeApiCallHook(
	'deselectModifier',
	deselectModifier
);

export const useIncreaseModifierLevel = makeApiCallHook(
	'increaseModifierLevel',
	increaseModifierLevel
);

export const useIncreaseModifierQuantity = makeApiCallHook(
	'increaseModifierQuantity',
	increaseModifierQuantity
);

export const useSelectModifier = makeApiCallHook(
	'selectModifier',
	selectModifier
);

export const useSelectProduct = makeApiCallHook('selectProduct', selectProduct);
